import { render, staticRenderFns } from "./GeneratedDocuments.vue?vue&type=template&id=97581114&scoped=true&"
import script from "./GeneratedDocuments.vue?vue&type=script&lang=js&"
export * from "./GeneratedDocuments.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedDocuments.vue?vue&type=style&index=0&id=97581114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97581114",
  null
  
)

export default component.exports